
import { defineComponent } from 'vue';
import ImmersionDatesComponent from '@/components/presentation/ImmersionDatesComponent.vue';

export default defineComponent({
	components: { ImmersionDatesComponent },
});
